/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Fatura_GereksinimlerInputs */

const tr_faq_a_fatura_gereksinimler = /** @type {(inputs: Faq_A_Fatura_GereksinimlerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QNB eSolutions entegrasyonunu aktif etmen gerekiyor. Ayarlar altındaki Pazaryeri Bağlantıları sayfasında QNB API bilgilerini girip bağlantıyı tamamlayabilirsin. Bunun dışında firmanın vergi levhası bilgilerinin (VKN veya TCKN) sisteme kayıtlı olması gerekir.`)
};

const en_faq_a_fatura_gereksinimler = /** @type {(inputs: Faq_A_Fatura_GereksinimlerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need to connect QNB eSolutions under Marketplace Connections in Settings. Your company's tax ID (VKN or TCKN) must also be on file.`)
};

const de_faq_a_fatura_gereksinimler = /** @type {(inputs: Faq_A_Fatura_GereksinimlerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du musst QNB eSolutions unter Einstellungen verbinden. Die Steuer-ID deines Unternehmens (VKN oder TCKN) muss ebenfalls hinterlegt sein.`)
};

const ru_faq_a_fatura_gereksinimler = /** @type {(inputs: Faq_A_Fatura_GereksinimlerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нужно подключить QNB eSolutions в разделе Настройки. ИНН компании (VKN или TCKN) также должен быть указан в системе.`)
};

/**
* | output |
* | --- |
* | "You need to connect QNB eSolutions under Marketplace Connections in Settings. Your company's tax ID (VKN or TCKN) must also be on file." |
*
* @param {Faq_A_Fatura_GereksinimlerInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_fatura_gereksinimler = /** @type {((inputs?: Faq_A_Fatura_GereksinimlerInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Fatura_GereksinimlerInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_fatura_gereksinimler(inputs)
	if (locale === "de") return de_faq_a_fatura_gereksinimler(inputs)
	if (locale === "ru") return ru_faq_a_fatura_gereksinimler(inputs)
	return tr_faq_a_fatura_gereksinimler(inputs)
});